module.exports = __webpack_public_path__ + "img/retail.3fc5cb53.jpeg";